import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  CHANGE_CALCULS_PAGE,
  CHANGE_CALCULS_SORT,
  DELETE_CALCUL,
  DELETE_CALCUL_SUCCESS,
  DUPLICATE_CALCUL,
  DUPLICATE_CALCUL_SUCCESS,
  LOAD_CALCUL,
  LOAD_CALCUL_FAILED,
  LOAD_CALCUL_SUCCESS,
  GET_USER_CALCULS_FAILED,
  GET_USER_CALCULS_SUCCESS,
  LOAD_USER_CALCULS,
  CLEAR_CALCUL,
  CLEAR_CALCUL_OBJECT,
  GET_ALL_USER_CALCULS_SUCCESS,
  GET_ALL_USER_CALCULS_FAILED,
  GET_ALL_USER_CALCULS,
  UPDATE_CALCULS_LIMIT,
  SET_CALCUL_ARCHIVED_FAILED,
  SET_CALCUL_ARCHIVED_SUCCESS,
  SET_CALCUL_ARCHIVED,
  RESTORE_ARCHIVED_CALCUL,
  RESTORE_ARCHIVED_CALCUL_SUCCESS,
  RESTORE_ARCHIVED_CALCUL_FAILED,
  CHANGE_CALCULS_SEARCH,
  UPDATE_CALCUL_ATTRIBUTES_SUCCESS,
  UPDATE_CALCUL_ATTRIBUTES_FAILED,
  UPDATE_CALCUL_ATTRIBUTES,
  MANAGE_CALCULS_BULK_SUCCESS,
  MANAGE_CALCULS_BULK_FAILED,
  MANAGE_CALCULS_BULK,
  UPDATE_CALCULS_FILTERS,
  UPGRADE_CALCUL_SUCCESS,
} from "../constants";
import {
  deleteCalculCall,
  duplicateCalculCall,
  getAllUserCalculsCall,
  getCalculCall,
  getUserCalculsCall,
  manageCalculAttributesCall,
  upgradeCalculCall,
  manageCalculsBulkCall,
} from "../../../APIClient";
import { parseResponse } from "../../../utils/http";
import { deleteCalculFailed } from "../actions";
import { clearRecalcAfterUpgrade } from "../../fdes/actions";
import { toast } from "react-toastify";
import {
  UPGRADE_CALCUL,
  CLEAR_CALCUL_INFORMATIONS,
} from "../../fdes/constants";
import {
  disableCalculLoader,
  enableCalculLoader,
} from "../../../common/actions/loader";
import { getArchivedCalculs, loadFolderCalculs } from "../../folders/actions";

function* getUserCalculs() {
  const getToken = (state) => state.user.informations.token;
  const getUserId = (state) => state.user.informations._id;
  const getCalculSort = (state) => state.calculs.sort;
  const getCalculLimit = (state) => state.calculs.limit;
  const getCalculPage = (state) => state.calculs.currentPage;
  const getSearch = (state) => state.calculs.search;
  const getLocalConfigurator = (state) => state.configurator.localConfigurator;
  const getFilters = (state) => state.calculs.filters;

  try {
    const token = yield select(getToken);
    const userId = yield select(getUserId);
    const sort = yield select(getCalculSort);
    const page = yield select(getCalculPage);
    const limit = yield select(getCalculLimit);
    const search = yield select(getSearch);
    const localConfigurator = yield select(getLocalConfigurator);
    const filters = yield select(getFilters);

    const data = yield call(
      getUserCalculsCall,
      token,
      userId,
      sort,
      page,
      limit,
      search,
      localConfigurator._id,
      filters,
    );
    yield call(parseResponse, data, GET_USER_CALCULS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_USER_CALCULS_FAILED, error });
  }
}

function* getCalcul(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    const data = yield call(getCalculCall, token, action.calculId);
    yield call(parseResponse, data, LOAD_CALCUL_SUCCESS);
  } catch (error) {
    yield call(toast.error, "Erreur lors du chargement du calcul");
    yield put({ type: LOAD_CALCUL_FAILED, error });
  }
}

function* deleteCalcul(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    const data = yield call(deleteCalculCall, token, action.calculId);
    yield call(parseResponse, data, DELETE_CALCUL_SUCCESS);
    yield call(toast.success, "Calcul supprimé");
  } catch (error) {
    yield call(toast.error, error.message);
    yield put(deleteCalculFailed());
  }
}

function* postUpgradeCalcul(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    yield put(enableCalculLoader());

    const data = yield call(upgradeCalculCall, token, action.calculId);
    yield call(parseResponse, data, UPGRADE_CALCUL_SUCCESS);

    yield call(toast.success, "Calcul mis à jour");
    yield put(disableCalculLoader());
  } catch (error) {
    yield call(toast.error, error.message);
    yield put(clearRecalcAfterUpgrade());
    yield put(disableCalculLoader());
  }
}

function* postDuplicateCalcul(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);
    yield put(enableCalculLoader());
    const data = yield call(duplicateCalculCall, token, action.calculId);
    yield call(parseResponse, data, DUPLICATE_CALCUL_SUCCESS);

    yield call(toast.success, "Calcul dupliqué");

    yield call(getUserCalculs);
    yield put(disableCalculLoader());
  } catch (error) {
    yield call(toast.error, error.message);
    yield put(disableCalculLoader());
  }
}

function* clearCalcul() {
  yield put({ type: CLEAR_CALCUL_OBJECT });
  yield put({ type: CLEAR_CALCUL_INFORMATIONS });
}

function* getAllUserCalculs() {
  const getToken = (state) => state.user.informations.token;
  const getLocalConfiguratorId = (state) =>
    state.configurator.localConfigurator._id;
  const getUserId = (state) => state.user.informations._id;

  try {
    const token = yield select(getToken);
    const localConfiguratorId = yield select(getLocalConfiguratorId);
    const userId = yield select(getUserId);

    const data = yield call(
      getAllUserCalculsCall,
      token,
      localConfiguratorId,
      userId,
    );
    yield call(parseResponse, data, GET_ALL_USER_CALCULS_SUCCESS);
  } catch (error) {
    yield put({ type: GET_ALL_USER_CALCULS_FAILED, error });
  }
}

function* setCalculArchived(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableCalculLoader());

    const data = yield call(
      manageCalculAttributesCall,
      token,
      action.calculId,
      {
        archived: true,
      },
    );
    if (action.folderId) {
      yield put(loadFolderCalculs(action.folderId));
    } else {
      yield call(getUserCalculs);
    }
    yield call(parseResponse, data, SET_CALCUL_ARCHIVED_SUCCESS);
    yield call(toast.success, "Calcul archivé");
    yield put(disableCalculLoader());
  } catch (error) {
    yield put({ type: SET_CALCUL_ARCHIVED_FAILED, error });
  }
}

function* restoreArchivedCalcul(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableCalculLoader());

    const data = yield call(
      manageCalculAttributesCall,
      token,
      action.calculId,
      {
        archived: false,
      },
    );
    yield put(getArchivedCalculs());
    yield call(parseResponse, data, RESTORE_ARCHIVED_CALCUL_SUCCESS);
    yield call(toast.success, "Calcul restauré");
    yield put(disableCalculLoader());
  } catch (error) {
    yield put({ type: RESTORE_ARCHIVED_CALCUL_FAILED, error });
  }
}

function* updateCalculAttributes(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableCalculLoader());

    const data = yield call(
      manageCalculAttributesCall,
      token,
      action.calculId,
      action.attributes,
    );
    yield call(parseResponse, data, UPDATE_CALCUL_ATTRIBUTES_SUCCESS);
    yield call(toast.success, "Calcul mis à jour");
    yield put(disableCalculLoader());
  } catch (error) {
    yield put({ type: UPDATE_CALCUL_ATTRIBUTES_FAILED, error });
  }
}

function* manageCalculsBulk(action) {
  const getToken = (state) => state.user.informations.token;

  try {
    const token = yield select(getToken);

    yield put(enableCalculLoader());

    const data = yield call(
      manageCalculsBulkCall,
      token,
      action.action,
      action.calculIds,
    );
    if (action.folderId) {
      yield put(loadFolderCalculs(action.folderId));
    } else {
      yield call(getUserCalculs);
    }
    yield call(parseResponse, data, MANAGE_CALCULS_BULK_SUCCESS);
    if (action.action === "duplicate") {
      yield call(toast.success, "Calculs dupliqués");
    } else if (action.action === "archive") {
      yield call(toast.success, "Calculs archivés");
    } else if (action.action === "delete") {
      yield call(toast.success, "Calculs supprimés");
    }
    yield put(disableCalculLoader());
  } catch (error) {
    yield put({ type: MANAGE_CALCULS_BULK_FAILED, error });
  }
}

export const calculsSagas = [
  takeLatest(LOAD_USER_CALCULS, getUserCalculs),
  takeLatest(CHANGE_CALCULS_SORT, getUserCalculs),
  takeLatest(CHANGE_CALCULS_PAGE, getUserCalculs),
  takeLatest(UPDATE_CALCULS_LIMIT, getUserCalculs),
  takeLatest(CHANGE_CALCULS_SEARCH, getUserCalculs),
  takeLatest(LOAD_CALCUL, getCalcul),
  takeLatest(DELETE_CALCUL, deleteCalcul),
  takeLatest(UPGRADE_CALCUL, postUpgradeCalcul),
  takeLatest(DUPLICATE_CALCUL, postDuplicateCalcul),
  takeLatest(CLEAR_CALCUL, clearCalcul),
  takeLatest(GET_ALL_USER_CALCULS, getAllUserCalculs),
  takeLatest(SET_CALCUL_ARCHIVED, setCalculArchived),
  takeLatest(RESTORE_ARCHIVED_CALCUL, restoreArchivedCalcul),
  takeLatest(UPDATE_CALCUL_ATTRIBUTES, updateCalculAttributes),
  takeLatest(MANAGE_CALCULS_BULK, manageCalculsBulk),
  takeLatest(UPDATE_CALCULS_FILTERS, getUserCalculs),
];
